import React, { useRef } from "react";
import type { EntityClickHandler } from "../../types/entityRegistry";
import EntityDetail from "./EntityDetail";
import OverlayWrapper from "./OverlayWrapper";

interface EntityDetailOverlayProps {
  entityId: string;
  // The singular type key, when the address names one beside the id
  entityType?: string;
  onClose: () => void;
  onEntityClick?: EntityClickHandler;
  onOpenInGraph?: (entityId: string) => void;
  onOpenInMap?: (
    entityName: string,
    entityType: string,
    entityId: string
  ) => void;
}

/**
 * The entity detail in a fixed overlay on the right of the page.
 * A wrapper around the detail dispatcher, for the pages that pass an id.
 */
const EntityDetailOverlay: React.FC<EntityDetailOverlayProps> = ({
  entityId,
  entityType,
  onClose,
  onEntityClick,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  if (!entityId) return null;

  return (
    <OverlayWrapper>
      <EntityDetail
        entityId={entityId}
        entityType={entityType}
        onClose={onClose}
        onEntityClick={onEntityClick}
        mode="overlay"
        scrollContainerRef={scrollContainerRef}
      />
    </OverlayWrapper>
  );
};

export default EntityDetailOverlay;
